import React, { FC } from 'react';

import { CloudStatusIcon } from '@evinced-private/ui-common';

import { ContactUsButton } from 'src/common/components/contact-us/ContactUsButton';
import { ProductType } from 'src/common/interfaces/Tenant';
import {
	DASHBOARD_ERROR_MSG,
	DASHBOARD_ERROR_TITLE,
	MOBILE_SDK_NO_TESTS_MSG,
	MOBILE_SDK_NO_TESTS_TITLE,
	NO_SYNCED_SESSIONS_MSG,
	NO_SYNCED_SESSIONS_TITLE
} from 'src/common/pages/dashboards-container/errorMessages';
import { LoadErrorMsgLayout } from 'src/common/pages/property/LoadErrorMsgLayout';

export const MobileErrorType = {
	NO_DATA: 'NO_DATA',
	LOADING_ERROR: 'LOADING_ERROR'
} as const;

export type MobileErrorType = (typeof MobileErrorType)[keyof typeof MobileErrorType];

interface ErrorConfig {
	title: string;
	message: string;
}

type ErrorConfigMap = Partial<Record<ProductType, Record<MobileErrorType, ErrorConfig>>>;

const ERROR_CONFIG_MAP: ErrorConfigMap = {
	[ProductType.MOBILE_SDK]: {
		[MobileErrorType.NO_DATA]: {
			title: MOBILE_SDK_NO_TESTS_TITLE,
			message: MOBILE_SDK_NO_TESTS_MSG
		},
		[MobileErrorType.LOADING_ERROR]: {
			title: DASHBOARD_ERROR_TITLE,
			message: DASHBOARD_ERROR_MSG
		}
	},
	[ProductType.MOBILE_FLOW_ANALYZER]: {
		[MobileErrorType.NO_DATA]: {
			title: NO_SYNCED_SESSIONS_TITLE,
			message: NO_SYNCED_SESSIONS_MSG
		},
		[MobileErrorType.LOADING_ERROR]: {
			title: DASHBOARD_ERROR_TITLE,
			message: DASHBOARD_ERROR_MSG
		}
	}
};

interface IErrorMessageProps {
	errorType: MobileErrorType;
	productType: ProductType;
}

export const MobileErrorMessage: FC<IErrorMessageProps> = ({ errorType, productType }) => {
	const errorConfig = ERROR_CONFIG_MAP[productType]?.[errorType] ?? {
		title: DASHBOARD_ERROR_TITLE,
		message: DASHBOARD_ERROR_MSG
	};

	return (
		<LoadErrorMsgLayout
			mainTitle={errorConfig.title}
			secondaryMsg={errorConfig.message}
			icon={CloudStatusIcon}
			className="mobile-error-message"
		>
			<ContactUsButton product={productType} />
		</LoadErrorMsgLayout>
	);
};
